import React, { useEffect } from 'react';
import './ps2023.css';
import { ps2023 } from '../../json/ps2023';

const Ps2023 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programas Sociales 2023</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'left' }}>
             
              <div style={{ textAlign: 'left' }}>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='/Psbienydes'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Apoyo Para el Bienestar y Desarrollo 2023</a></strong></h5>
                <p>
                </p>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='/Psbienmas'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Bienestar de Madres Solteras 2023</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='/Psbiendisc'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Bienestar de las Personas Con Discapacidad 2023</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='/Psfomdps'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa Fomento al Desarrollo de la Participación Social 2023</a></strong></h5>
                <p>
                </p>
                
                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='/Psfomart'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Fomento Artesanal 2023</a></strong></h5>
                <p>
                </p>

                <h5 style={{ fontWeight: 'bold' }}><strong><a
                href='/Psatencionm'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >Programa de Atención a Migrantes 2023</a></strong></h5>
                <p>
                </p>

              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Ps2023;